<template>
    <label for="{{ id }}" class="h5">{{ label }}</label>
    <select class="custom-select" id="{{ id }}" @change="onSettingsChanged($event.target.value)">
        <template v-for=" device of devices">
            {{ device.label }}
        </template>
    </select>
</template>

<script>
import { StorageService } from "@/service/crmservice/StorageService";
import { ref, onMounted} from "vue";

export default ({
    name: 'DeviceSelect',
    props: {
        KeyData: String,
        kind: String,
        label: String,
        devices: String,
    },
    
    setup(props, ctx) {

          //====================== Variable ===========================

        const localDevices = ref([]);
        const storageService = ref(new StorageService());
        const id = ref(null);


        //====================== Funcations ===========================

        const getOrAdd = (key, devices) => {
            const existingId = storageService.value.get(key);
            if (devices && devices.length > 0) {
                const defaultDevice = devices.find(d => d.deviceId === existingId) || devices[0];
                storageService.value.set(key, defaultDevice.deviceId);
                return defaultDevice.deviceId;
            }
            return null;
        }
        const selectedId = ref(getOrAdd(props.KeyData, props.devices));

        const onSettingsChanged = (deviceId) => {
            setAndEmitSelections(props.KeyData, selectedId.value = deviceId);
        }

      

        const setAndEmitSelections = (key, deviceId) => {
            storageService.value.set(key, deviceId);
            ctx.emit("settingsChanged",props.devices.find(d => d.deviceId === deviceId));
        }


        //====================== onMounted ===========================

        onMounted(() => {

        });

        //====================== return ===========================

        return {
            id,
            selectedId,
            localDevices,
            setAndEmitSelections,
            getOrAdd,
            onSettingsChanged
        }
    },
})
</script>
